module.exports = __webpack_public_path__ + "img/support-promo-bg-900-599.9dadb4d.jpg";